import { DateOption, QuarterOption } from './date-range-selector.service';
const DATE_FILTER_I18N_PATH = 'FRONTEND.DATE_RANGE_SELECTOR.FILTERS.DATE';
const QUARTER_FILTER_I18N_PATH = 'FRONTEND.DATE_RANGE_SELECTOR.FILTERS.QUARTER';

export enum DateFilterOptions {
  Custom,
  SevenDay,
  ThirtyDay,
  ThreeMonth,
  SixMonth,
  TwelveMonth,
  Month,
  Quarter,
}

export enum QuarterFilterOption {
  First_Quarter,
  Second_Quarter,
  Third_Quarter,
  Fourth_Quarter,
}

export const DATE_FILTERS: DateOption[] = [
  {
    key: DateFilterOptions.Custom,
    i18nKey: `${DATE_FILTER_I18N_PATH}.CUSTOM`,
  },
  {
    key: DateFilterOptions.SevenDay,
    i18nKey: `${DATE_FILTER_I18N_PATH}.SEVEN_DAYS`,
    daysOffset: 7,
  },
  {
    key: DateFilterOptions.ThirtyDay,
    i18nKey: `${DATE_FILTER_I18N_PATH}.THIRTY_DAYS`,
    daysOffset: 30,
  },
  {
    key: DateFilterOptions.ThreeMonth,
    i18nKey: `${DATE_FILTER_I18N_PATH}.NINETY_DAYS`,
    daysOffset: 90,
  },
  {
    key: DateFilterOptions.SixMonth,
    i18nKey: `${DATE_FILTER_I18N_PATH}.SIX_MONTHS`,
    daysOffset: 180,
    monthsOffset: 6,
  },
  {
    key: DateFilterOptions.TwelveMonth,
    i18nKey: `${DATE_FILTER_I18N_PATH}.TWELVE_MONTHS`,
    daysOffset: 365,
    monthsOffset: 12,
  },
];

export const SEASON_FILTERS: DateOption[] = [
  {
    key: DateFilterOptions.Month,
    i18nKey: `${DATE_FILTER_I18N_PATH}.MONTH`,
  },
  {
    key: DateFilterOptions.Quarter,
    i18nKey: `${DATE_FILTER_I18N_PATH}.QUARTER`,
  },
];

export const QUARTER_FILTERS: QuarterOption[] = [
  {
    section: QuarterFilterOption.First_Quarter,
    i18nKey: `${QUARTER_FILTER_I18N_PATH}.FIRST_QUARTER`,
    startMonth: 1,
    endMonth: 3,
  },
  {
    section: QuarterFilterOption.Second_Quarter,
    i18nKey: `${QUARTER_FILTER_I18N_PATH}.SECOND_QUARTER`,
    startMonth: 4,
    endMonth: 6,
  },
  {
    section: QuarterFilterOption.Third_Quarter,
    i18nKey: `${QUARTER_FILTER_I18N_PATH}.THIRD_QUARTER`,
    startMonth: 7,
    endMonth: 9,
  },
  {
    section: QuarterFilterOption.Fourth_Quarter,
    i18nKey: `${QUARTER_FILTER_I18N_PATH}.FOURTH_QUARTER`,
    startMonth: 10,
    endMonth: 12,
  },
];
